module.exports = __webpack_public_path__ + "static/media/mission-broden-ic.225bd034.svg";